module.exports = __webpack_public_path__ + "img/Slide23.f1030d88.png";